/** 回合时间线列表与详情。字段与服务端 snake_case 响应同名透传。 */

import { llmHttp } from './http.js'

/**
 * @param {{ since: string, until: string, page?: number, limit?: number }} query
 * @returns {Promise<object>}
 */
export function listTurnTimelines(query) {
  return llmHttp().get('/turn-timelines', {
    query,
    routeId: 'llm.admin.turnTimelines.list',
  })
}

/** @param {string} turnId @returns {Promise<object>} */
export function getTurnTimeline(turnId) {
  return llmHttp().get(`/turn-timelines/${encodeURIComponent(turnId)}`, {
    routeId: 'llm.admin.turnTimelines.detail',
  })
}
